(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["slideshow-controls"] && !Shopify.designMode) return;
  try {
    if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
  document.querySelectorAll('.slideshow-controls__tab').forEach((tab) => {
    tab.addEventListener('mouseenter', () => tab.click());
  });
}
document.querySelectorAll('slideshow-component').forEach((component) => {
  const labels = component.querySelectorAll('.slide-tab-label');
  const tabs = component.querySelectorAll('.slideshow-controls__tab');
  labels.forEach((label, i) => {
    if (tabs[i]) tabs[i].textContent = label.textContent;
  });
});
  } catch(e) { console.error(e); }
})();

})();
